exports = module.exports = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-box[data-v-3dd201bc]  .el-dialog__body{max-height:610px;overflow-y:auto}", ""]);

// exports
